// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__VMJ51","rootSmall":"AddTileButton_rootSmall__2IjMH"};